import {Component, inject, OnInit} from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HeaderComponent} from "../../../common/header/header.component";

import {LocaleService} from "../../../../locale/locale.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {ClaimsService} from "../../../../services/claims.service";
import {TechnicalReasonType} from "../../../../enums/technical-reason-type";
import {TextAreaComponent} from "../../../common/text-area/text-area.component";

@Component({
  selector: 'app-potential-technical-defect',
  imports: [
    FooterComponent,
    FormsModule,
    HeaderComponent,
    ReactiveFormsModule,
    TextAreaComponent
  ],
  templateUrl: './potential-technical-defect.component.html',
  styleUrl: './potential-technical-defect.component.css'
})
export class PotentialTechnicalDefectComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  showError: boolean = false;
  options: { headline: string, caption: string, value: string }[] = [];
  radioControl = new FormControl();
  technicalIssueExplanation: string | null = null;

  ngOnInit(): void {
    this.options = [
      {
        headline: this.locale.currentTranslation.yes,
        caption: '',
        value: TechnicalReasonType.Yes
      },
      {
        headline: this.locale.currentTranslation.no,
        caption: '',
        value: TechnicalReasonType.No
      },
      {
        headline: this.locale.currentTranslation.unsure,
        caption: '',
        value: TechnicalReasonType.Unsure
      }
    ];
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.technicalIssue) {
        this.radioControl = new FormControl(this.claimService.claimReport().technicalIssue);
      }
      if (this.claimService.claimReport()?.technicalIssueExplanation) {
        this.technicalIssueExplanation = this.claimService.claimReport().technicalIssueExplanation;
      }
    })
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showError) {
      this.claimService.updateClaimReport({
        technicalIssue: this.radioControl.getRawValue(),
        technicalIssueExplanation: this.technicalIssueExplanation
      });
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['potential-technical-defect']);
      });
    }
  }

  private evaluateShowError() {
    let rawValue = this.radioControl.getRawValue();
    if (rawValue === TechnicalReasonType.Yes) {
      this.showError = this.technicalIssueExplanation === null || this.technicalIssueExplanation.length <= 0;
    } else {
      this.showError = rawValue === null;
    }
  }

  setOption(value: string) {
    this.radioControl.patchValue(value);
    this.showError = false;
  }

  protected readonly TechnicalReasonType = TechnicalReasonType;
}
